import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=2701bac6&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=2701bac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701bac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2701bac6')) {
      api.createRecord('2701bac6', component.options)
    } else {
      api.reload('2701bac6', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=2701bac6&scoped=true&", function () {
      api.rerender('2701bac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZPHOyqfvQiI5/JS/teamMember.vue"
export default component.exports